import { IAlertNameDictionaryApi } from '@/types';

export class AlertNameDictionaryItem {
    code: string;
    id: number;
    is_customer_view?: number;
    /** Display name (from code for dictionary compatibility) */
    name: string;
    priority_id?: number;

    constructor(data: IAlertNameDictionaryApi) {
        this.id = data.id;
        this.code = data.code;
        this.name = data.code;
        this.priority_id = data.priority_id;
        this.is_customer_view = data.is_customer_view;
    }
}
